<!-- <chat-tabs [selectedRoomId]="roomId" (onRoomSelected)="onRoomSelected($event)"></chat-tabs>
<div id="card">
    <div class="front">
        <div *ngIf="roomId">
            <chat-room role="tabpanel" [roomid]="roomId" aria-labelledby="roomId" (onRoomClosed)="onRoomClosed($event)"
                (onAddGuestToRoom)="onAddGuestToRoom($event)"></chat-room>
        </div>
    </div>
    <div class="back">
        <div *ngIf="flipped">
            <chat-list [roomid]="confId" (onLeaveConferenceList)="onLeaveConferenceList()"
                (onNewRoom)="onNewRoom($event)"></chat-list>
        </div>
    </div>
</div> -->
<ng-container *ngIf="flipped; then listView; else roomView"></ng-container>

<ng-template #listView>
  <chat-list [roomid]="confId" (onLeaveConferenceList)="onLeaveConferenceList()" (onNewRoom)="onNewRoom($event)"> </chat-list>
</ng-template>

<ng-template #roomView>
  <div title="{{ 'commons:chat.new-conversation' | translate }}" class="add-btn">
    <button mat-icon-button class="add-btn cng-ico_add" (click)="newRoom()" [disabled]="disableAddRoomButton()"></button>
  </div>
  <mat-tab-group>
    <mat-tab *ngFor="let room of rooms">
      <ng-template mat-tab-label>
        <span class="tab-text" title="{{ tabLabel(room) }}">
          <ng-container *ngIf="roomParticipantCount(room) === 1">
            {{ tabLabel(room) }}
          </ng-container>
          <ng-container *ngIf="roomParticipantCount(room) > 1">
            {{ roomParticipantCount(room) }}
          </ng-container>
          <ng-container *ngIf="room.nbUnreadMessages > 0">{{ room.nbUnreadMessages }}</ng-container>
        </span>
      </ng-template>
      <chat-room [roomid]="room.id" (onRoomClosed)="onRoomClosed($event)" (onAddGuestToRoom)="onAddGuestToRoom($event)"> </chat-room>
    </mat-tab>
  </mat-tab-group>
</ng-template>
